<!-- The app dialogs (UiDialog.vue, z-[99], the latest on top), the thumbs-up of important moments (#uiOk, z-[98], 1.6 s;
     a new one replaces it) and the online-save notice at the bottom (#syncToast, z-[85], fades out after 3.5 s), all from
     src/stores/notices.ts. Teleported to <body> like the legacy elements. -->
<script setup lang="ts">
import UiDialog from './UiDialog.vue'
import { useNoticesStore } from '../../stores/notices'

const notices = useNoticesStore()
</script>

<template>
  <Teleport to="body">
    <UiDialog v-for="d in notices.dialogs" :key="d.id" :item="d" />
    <div v-if="notices.ok" id="uiOk" :key="notices.ok.seq" class="ui-ok fixed inset-0 z-[98] flex flex-col items-center justify-center gap-3 pointer-events-none">
      <span class="relative w-20 h-20"><span class="ui-ok-ring absolute inset-0 rounded-full border-4 border-brand"></span>
        <span class="ui-ok-ico absolute inset-0 rounded-full bg-brand text-white flex items-center justify-center text-3xl shadow-2xl"><i class="fas fa-thumbs-up"></i></span></span>
      <span class="px-4 py-1.5 rounded-full bg-darkcard border border-gray-800 shadow-xl text-sm font-bold text-gray-100">{{ notices.ok.text }}</span>
    </div>
    <div v-if="notices.toast.shown" id="syncToast" class="fixed left-1/2 -translate-x-1/2 bottom-24 md:bottom-8 z-[85] max-w-[calc(100vw-2rem)] px-4 py-2.5 rounded-full bg-darkcard border border-gray-800 shadow-2xl text-xs font-semibold text-gray-100 transition-opacity duration-300 pointer-events-none"
      :style="{ opacity: notices.toast.on ? '1' : '0' }"><i class="fas fa-cloud text-brand mr-2"></i>{{ notices.toast.text }}</div>
  </Teleport>
</template>
